import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStoreAlt } from '@fortawesome/pro-regular-svg-icons';
import {
  DialogContent, TextField, Grid, Typography
} from '@mui/material';
import { translate } from 'utils';

import { FormElement } from 'components/_commons';
import { HeaderModal } from './_HeaderModal';
import { CustomActionButtons } from './_CustomActionButtons';

export const CreateGroupModal = ({
                                   onConfirm, onClose, closeOnSubmit, defaultValues
                                 }) => {
  const [isLoading, setIsLoading] = useState(false);

  const { control, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      name: defaultValues.name || '',
      identifier: defaultValues.identifier || '',
      ...defaultValues
    }
  });

  const onSubmit = data => {
    setIsLoading(true);

    onConfirm({
      ...data,
      hashId: defaultValues.hashId || null
    }).finally(() => setIsLoading(false));

    if (closeOnSubmit) {
      onClose();
    }
  };

  return (
    <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
      <HeaderModal onClose={onClose}>
        <FontAwesomeIcon icon={faStoreAlt} />
        <Typography component="span">
          {defaultValues && defaultValues.groupName
                ? translate('modalGroup.editGroupe')
                : translate('modalGroup.newGroup')}
        </Typography>
      </HeaderModal>

      <DialogContent style={{ paddingTop: '10px' }}>
        <Grid container direction="column">
          <FormElement>
            <Controller
                  control={control}
                  name="name"
                  render={({ field }) => (
                    <TextField
                          {...field}
                          autoFocus
                          error={!!errors.name}
                          label={translate('common.groupName')}
                          required
                      />
                  )}
                  rules={{ required: true }}
              />
            <Controller
                  control={control}
                  name="identifier"
                  render={({ field }) => (
                    <TextField
                          {...field}
                          error={!!errors.identifier}
                          label={translate('common.groupIdentifier')}
                          required
                      />
                  )}
                  rules={{ required: true }}
              />
          </FormElement>
        </Grid>
      </DialogContent>

      <CustomActionButtons
            isLoading={isLoading}
            isValidated={defaultValues.validated}
            onClose={onClose}
        />
    </form>
  );
};

CreateGroupModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  closeOnSubmit: PropTypes.bool,
  defaultValues: PropTypes.shape({})
};

CreateGroupModal.defaultProps = {
  closeOnSubmit: true,
  defaultValues: {}
};
